module.exports = __webpack_public_path__ + "img/gzh.76be2a9f.png";